import { useState } from "react";
import "@/App.css";
import { MessageCircle, Instagram, Music, X, Facebook, Phone, Mail, MapPin } from "lucide-react";

function App() {
  const [currentPage, setCurrentPage] = useState("home");
  const [showToast, setShowToast] = useState(false);

  const showPage = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sendForm = () => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 4000);
  };

  return (
    <div className="App" data-testid="alsuraa-app">
      {/* TOP BAR */}
      <div className="top-bar" data-testid="top-bar">
        <button className="consult-btn" onClick={() => showPage("contact")} data-testid="consult-btn">
          استشارة مجانية
        </button>
        <div className="social-icons">
          <a href="https://wa.me/966920020557" target="_blank" rel="noopener noreferrer" title="واتساب" data-testid="social-whatsapp">
            <MessageCircle size={14} />
          </a>
          <a href="#" title="إنستغرام" data-testid="social-instagram"><Instagram size={14} /></a>
          <a href="#" title="تيك توك" data-testid="social-tiktok"><Music size={14} /></a>
          <a href="#" title="تويتر" data-testid="social-twitter"><X size={14} /></a>
          <a href="#" title="فيسبوك" data-testid="social-facebook"><Facebook size={14} /></a>
        </div>
        <div className="top-bar-text">شركة السرعة - أفضل شركة استقدام عمالة في حائل</div>
      </div>

      {/* NAV */}
      <nav data-testid="main-nav">
        <div className="logo" onClick={() => showPage("home")} data-testid="logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_kind-euclid-5/artifacts/fex1xyc7_WhatsApp%20Image%202026-03-02%20at%206.43.32%20PM.jpeg" 
            alt="شركة السرعة للاستقدام" 
            className="logo-img"
          />
        </div>
        <div className="nav-links">
          <a onClick={() => showPage("home")} className={currentPage === "home" ? "active" : ""} data-testid="nav-home">الرئيسية</a>
          <a onClick={() => showPage("prices")} className={currentPage === "prices" ? "active" : ""} data-testid="nav-prices">أسعار الاستقدام</a>
          <a onClick={() => showPage("rental")} className={currentPage === "rental" ? "active" : ""} data-testid="nav-rental">عاملات الإيجار</a>
          <a onClick={() => showPage("steps")} className={currentPage === "steps" ? "active" : ""} data-testid="nav-steps">خطوات الاستقدام</a>
          <a onClick={() => showPage("about")} className={currentPage === "about" ? "active" : ""} data-testid="nav-about">عن الاستقدام</a>
          <a onClick={() => showPage("articles")} className={currentPage === "articles" ? "active" : ""} data-testid="nav-articles">مقالات</a>
          <button className="nav-contact-btn" onClick={() => showPage("contact")} data-testid="nav-contact-btn">تواصل معنا</button>
        </div>
      </nav>

      {/* HOME PAGE */}
      {currentPage === "home" && (
        <div data-testid="page-home">
          {/* HERO */}
          <div className="hero" data-testid="hero-section">
            <div className="hero-bg"></div>
            <div className="hero-pattern"></div>
            <div className="hero-content">
              <div className="hero-badge">شركة السرعة للاستقدام - حائل</div>
              <h1 className="hero-title">الخيار الأول لاستقدام<br />الأيدي العاملة</h1>
              <div className="hero-divider"></div>
              <p className="hero-sub">عائلتك سعيدة، حياتك سهلة</p>
              <button onClick={() => showPage("contact")} className="hero-cta" data-testid="hero-contact-btn">اتصل بنا الآن</button>
              <a href="https://wa.me/966920020557" target="_blank" rel="noopener noreferrer" className="hero-cta outline" data-testid="hero-whatsapp-btn">
                <MessageCircle size={18} style={{ marginLeft: "8px" }} /> واتساب
              </a>
            </div>
          </div>

          {/* SERVICES ROW */}
          <div className="services-row" data-testid="services-row">
            <div className="service-card" onClick={() => showPage("steps")} data-testid="service-visa">
              <div className="service-icon">📋</div>
              <h3>إصدار التأشيرة</h3>
              <p>استخراج التأشيرة إلكترونياً بسهولة عبر موقع مساند الإلكتروني</p>
            </div>
            <div className="service-card" onClick={() => showPage("about")} data-testid="service-workers">
              <div className="service-icon">👥</div>
              <h3>اختيار العمالة</h3>
              <p>اختيار وترشيح الأفضل من بين العمالة المنزلية حول العالم</p>
            </div>
            <div className="service-card" onClick={() => showPage("about")} data-testid="service-contract">
              <div className="service-icon">📝</div>
              <h3>تعاقد الاستقدام</h3>
              <p>فريق من أفضل المتخصصين بخبرة كبيرة في استقدام العمالة المنزلية</p>
            </div>
          </div>

          {/* ABOUT */}
          <div className="section section-light" data-testid="about-section">
            <div className="about-flex">
              <div className="about-text">
                <div className="section-badge">من نحن</div>
                <h2>أن نكون الخيار الأول<br />للاستقدام في حائل</h2>
                <p>تقديم خدمات استقدام الأيدي العاملة ذات المؤهلات والخبرات والكفاءات العالية والمتميزة، والالتزام برضا العميل من خلال فريق عمل مؤهل ومدرب يطبق أعلى معايير الجودة والتميز.</p>
                <p>مع شركة السرعة <strong>عائلتك سعيدة وحياتك سهلة</strong> — ركزي في دوامك وعملك واتركي الأعمال المنزلية علينا.</p>
                <div className="about-highlights">
                  <div className="highlight-item">
                    <div className="highlight-num">+500</div>
                    <div className="highlight-label">عميل راضٍ</div>
                  </div>
                  <div className="highlight-item">
                    <div className="highlight-num">+15</div>
                    <div className="highlight-label">دولة مصدر</div>
                  </div>
                  <div className="highlight-item">
                    <div className="highlight-num">100%</div>
                    <div className="highlight-label">ضمان الجودة</div>
                  </div>
                </div>
              </div>
              <div className="about-visual">
                <div className="about-v-card">
                  <h4>🏆 رؤيتنا</h4>
                  <p>أن نكون الشركة الرائدة في استقدام العمالة المنزلية بمنطقة حائل وأن نقدم خدمة استثنائية لعملائنا</p>
                </div>
                <div className="about-v-card">
                  <h4>📋 إصدار التأشيرة</h4>
                  <p>استخراج سريع وإلكتروني عبر مساند بخطوات بسيطة</p>
                </div>
                <div className="about-v-card">
                  <h4>✅ ضمان الجودة</h4>
                  <p>فحص دوري مستمر لمقدمي الخدمة</p>
                </div>
                <div className="about-v-card">
                  <h4>📞 دعم متواصل</h4>
                  <p>خدمة عملاء عبر قنوات متعددة على مدار الساعة</p>
                </div>
              </div>
            </div>
          </div>

          {/* FEATURES */}
          <div className="section section-white" data-testid="features-section">
            <div className="section-header">
              <div className="section-badge">مميزاتنا</div>
              <h2 className="section-title">لماذا تختار شركة السرعة؟</h2>
              <p className="section-sub">نقدم لعملائنا تجربة استقدام متكاملة بأعلى معايير الجودة والاحترافية</p>
            </div>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">🏆</div>
                <h3>خدمة عملاء متميزة</h3>
                <p>نهتم بخدمتكم عبر قنوات تواصل متعددة ونضمن لكم خدمة متكاملة وتجربة مميزة لا تُنسى</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">💻</div>
                <h3>خدمات رقمية متكاملة</h3>
                <p>ابدأ حجزك وأتمم دفعك من خلال الموقع الإلكتروني بوقت وجيز وخطوات مختصرة</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🔍</div>
                <h3>فحص مستمر للعمالة</h3>
                <p>يخضع مقدمو الخدمة للفحص باستمرار من أجل خدمتكم وراحتكم وضمان أفضل اختيار</p>
              </div>
            </div>
          </div>

          {/* BANNER */}
          <div className="banner" data-testid="banner-section">
            <h2>عائلتك سعيدة، حياتك سهلة</h2>
            <p>ركزي في دوامك وعملك واتركي الأعمال المنزلية علينا</p>
            <button onClick={() => showPage("contact")} className="hero-cta" style={{ margin: 0 }} data-testid="banner-contact-btn">احصل على استشارة مجانية</button>
          </div>

          {/* SERVICES DETAIL */}
          <div className="section section-light" data-testid="services-detail-section">
            <div className="section-header">
              <div className="section-badge">خدماتنا</div>
              <h2 className="section-title">خدمات شركة السرعة</h2>
              <p className="section-sub">الخدمات التي نقدمها لعملائنا المميزين بأعلى جودة وأسرع وقت</p>
            </div>
            <div className="services-grid">
              <div className="svc-card"><div className="svc-num">01</div><h3>سداد التأشيرة</h3><p>سداد رسوم التأشيرة للعمالة المنزلية عبر البنك أو وسائل الدفع المتاحة (فيزا، ماستركارد، مدى)</p></div>
              <div className="svc-card"><div className="svc-num">02</div><h3>إصدار التأشيرات</h3><p>طلب إصدار تأشيرة العمالة المنزلية الخاصة بك في برنامج مساند بسهولة وسرعة</p></div>
              <div className="svc-card"><div className="svc-num">03</div><h3>اختيار السيرة الذاتية</h3><p>اختيار وترشيح الأفضل من بين العمالة المنزلية لتوفير أفضل الكفاءات المدربة بحرفية عالية</p></div>
              <div className="svc-card"><div className="svc-num">04</div><h3>تعاقد الاستقدام</h3><p>فريق من أفضل المتخصصين في مجالات استقدام العمالة بخبرة كبيرة في توظيف الكوادر البشرية</p></div>
              <div className="svc-card"><div className="svc-num">05</div><h3>وصول العمالة المنزلية</h3><p>نضمن تقديم خدمات سريعة ومتابعة مستمرة للعميل بإبلاغه بوقت وصول العمالة الوافدة</p></div>
              <div className="svc-card"><div className="svc-num">06</div><h3>سياسات وقوانين الاستقدام</h3><p>نرشدك لكافة الضوابط والقوانين المعتمدة من الحكومة السعودية لضمان حقوقك وحقوق العمالة</p></div>
            </div>
          </div>
        </div>
      )}

      {/* PRICES PAGE */}
      {currentPage === "prices" && (
        <div data-testid="page-prices">
          <div className="page-header">
            <div className="section-badge gold">الأسعار</div>
            <h1>أسعار استقدام العمالة المنزلية</h1>
            <p>أسعار تنافسية وشفافة لجميع الجنسيات</p>
          </div>
          <div className="section section-light">
            <div className="section-header">
              <div className="section-badge">اختر الجنسية</div>
              <h2 className="section-title">أسعار الاستقدام حسب الجنسية</h2>
              <p className="section-sub">جميع الأسعار بالريال السعودي وتشمل جميع الرسوم والإجراءات</p>
            </div>
            <div className="prices-grid">
              <div className="price-card" data-testid="price-philippines">
                <div className="price-flag">
                  <img src="https://flagcdn.com/w80/ph.png" alt="الفلبين" />
                </div>
                <h3>الفلبين</h3>
                <div className="price-amount">14,400</div>
                <div className="price-currency">ريال سعودي</div>
                <ul className="price-features">
                  <li>✅ عمالة مدربة ومؤهلة</li>
                  <li>✅ خبرة في الأعمال المنزلية</li>
                  <li>✅ إجادة اللغة الإنجليزية</li>
                </ul>
                <button className="price-btn" onClick={() => showPage("contact")}>اطلب الآن</button>
              </div>
              <div className="price-card" data-testid="price-srilanka">
                <div className="price-flag">
                  <img src="https://flagcdn.com/w80/lk.png" alt="سريلانكا" />
                </div>
                <h3>سريلانكا</h3>
                <div className="price-amount">14,000</div>
                <div className="price-currency">ريال سعودي</div>
                <ul className="price-features">
                  <li>✅ عمالة ذات خبرة عالية</li>
                  <li>✅ التزام وإتقان في العمل</li>
                  <li>✅ مهارات متعددة</li>
                </ul>
                <button className="price-btn" onClick={() => showPage("contact")}>اطلب الآن</button>
              </div>
              <div className="price-card" data-testid="price-bangladesh">
                <div className="price-flag">
                  <img src="https://flagcdn.com/w80/bd.png" alt="بنجلاديش" />
                </div>
                <h3>بنجلاديش</h3>
                <div className="price-amount">6,994</div>
                <div className="price-currency">ريال سعودي</div>
                <ul className="price-features">
                  <li>✅ عمالة مجتهدة ونشيطة</li>
                  <li>✅ أسعار مناسبة</li>
                  <li>✅ سرعة في الإجراءات</li>
                </ul>
                <button className="price-btn" onClick={() => showPage("contact")}>اطلب الآن</button>
              </div>
              <div className="price-card" data-testid="price-kenya">
                <div className="price-flag">
                  <img src="https://flagcdn.com/w80/ke.png" alt="كينيا" />
                </div>
                <h3>كينيا</h3>
                <div className="price-amount">5,094</div>
                <div className="price-currency">ريال سعودي</div>
                <ul className="price-features">
                  <li>✅ عمالة نشيطة ومتعاونة</li>
                  <li>✅ قدرة على التأقلم</li>
                  <li>✅ أسعار اقتصادية</li>
                </ul>
                <button className="price-btn" onClick={() => showPage("contact")}>اطلب الآن</button>
              </div>
              <div className="price-card" data-testid="price-burundi">
                <div className="price-flag">
                  <img src="https://flagcdn.com/w80/bi.png" alt="بورندي" />
                </div>
                <h3>بورندي</h3>
                <div className="price-amount">5,094</div>
                <div className="price-currency">ريال سعودي</div>
                <ul className="price-features">
                  <li>✅ عمالة ملتزمة</li>
                  <li>✅ سرعة في التعلم</li>
                  <li>✅ أسعار منافسة</li>
                </ul>
                <button className="price-btn" onClick={() => showPage("contact")}>اطلب الآن</button>
              </div>
              <div className="price-card" data-testid="price-uganda">
                <div className="price-flag">
                  <img src="https://flagcdn.com/w80/ug.png" alt="أوغندا" />
                </div>
                <h3>أوغندا</h3>
                <div className="price-amount">3,994</div>
                <div className="price-currency">ريال سعودي</div>
                <ul className="price-features">
                  <li>✅ عمالة متعاونة</li>
                  <li>✅ أسعار اقتصادية</li>
                  <li>✅ إجراءات سريعة</li>
                </ul>
                <button className="price-btn" onClick={() => showPage("contact")}>اطلب الآن</button>
              </div>
              <div className="price-card best-price" data-testid="price-ethiopia">
                <div className="best-badge">أفضل سعر</div>
                <div className="price-flag">
                  <img src="https://flagcdn.com/w80/et.png" alt="إثيوبيا" />
                </div>
                <h3>إثيوبيا</h3>
                <div className="price-amount">3,800</div>
                <div className="price-currency">ريال سعودي</div>
                <ul className="price-features">
                  <li>✅ أقل سعر متاح</li>
                  <li>✅ عمالة نشيطة</li>
                  <li>✅ إجراءات سهلة</li>
                </ul>
                <button className="price-btn" onClick={() => showPage("contact")}>اطلب الآن</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* RENTAL WORKERS PAGE */}
      {currentPage === "rental" && (
        <div data-testid="page-rental">
          <div className="page-header">
            <div className="section-badge gold">خدمة الإيجار</div>
            <h1>عاملات الإيجار</h1>
            <p>خدمة تأجير العاملات المنزلية بنظام مرن يناسب احتياجاتك</p>
          </div>
          <div className="section section-light">
            <div className="rental-intro">
              <h3>🏠 ما هي خدمة عاملات الإيجار؟</h3>
              <p>خدمة تأجير العاملات المنزلية هي الحل الأمثل لمن يحتاج عاملة منزلية لفترة محددة دون الحاجة للاستقدام الكامل. نوفر لكم عاملات مدربات وذوات خبرة من جنسيات متعددة بنظام إيجار يومي أو شهري.</p>
            </div>
            <div className="section-header">
              <div className="section-badge">الجنسيات المتاحة</div>
              <h2 className="section-title">عاملات الإيجار من جنسيات متعددة</h2>
              <p className="section-sub">نوفر عاملات مدربات من أفضل الجنسيات</p>
            </div>
            <div className="rental-grid">
              <div className="rental-card" data-testid="rental-kenya">
                <div className="rental-flag">
                  <img src="https://flagcdn.com/w80/ke.png" alt="كينيا" />
                </div>
                <h3>كينيا</h3>
                <p>عاملات كينيات مدربات على الأعمال المنزلية ورعاية الأطفال</p>
              </div>
              <div className="rental-card" data-testid="rental-ethiopia">
                <div className="rental-flag">
                  <img src="https://flagcdn.com/w80/et.png" alt="إثيوبيا" />
                </div>
                <h3>إثيوبيا</h3>
                <p>عاملات إثيوبيات نشيطات ومجتهدات في العمل المنزلي</p>
              </div>
              <div className="rental-card" data-testid="rental-srilanka">
                <div className="rental-flag">
                  <img src="https://flagcdn.com/w80/lk.png" alt="سريلانكا" />
                </div>
                <h3>سريلانكا</h3>
                <p>عاملات سريلانكيات ذوات خبرة عالية في جميع الأعمال المنزلية</p>
              </div>
              <div className="rental-card" data-testid="rental-indonesia">
                <div className="rental-flag">
                  <img src="https://flagcdn.com/w80/id.png" alt="إندونيسيا" />
                </div>
                <h3>إندونيسيا</h3>
                <p>عاملات إندونيسيات ماهرات في الطبخ والتنظيف ورعاية الأسرة</p>
              </div>
            </div>
            <div className="rental-features">
              <div className="section-header">
                <div className="section-badge">المميزات</div>
                <h2 className="section-title">مميزات خدمة الإيجار</h2>
              </div>
              <div className="features-grid">
                <div className="feature-card">
                  <div className="feature-icon">⏰</div>
                  <h3>مرونة في الوقت</h3>
                  <p>اختر المدة التي تناسبك - يومي، أسبوعي، أو شهري حسب احتياجاتك</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">💰</div>
                  <h3>توفير في التكاليف</h3>
                  <p>لا حاجة لتكاليف الاستقدام الكاملة - ادفع فقط مقابل الفترة المطلوبة</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">🔄</div>
                  <h3>إمكانية الاستبدال</h3>
                  <p>في حال عدم التوافق، يمكنك طلب استبدال العاملة بسهولة</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">✅</div>
                  <h3>عاملات مدربات</h3>
                  <p>جميع العاملات خضعن لتدريب مكثف وفحوصات طبية شاملة</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">📞</div>
                  <h3>دعم متواصل</h3>
                  <p>فريق دعم متاح على مدار الساعة لحل أي مشكلة أو استفسار</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">🛡️</div>
                  <h3>ضمان الجودة</h3>
                  <p>نضمن لك جودة الخدمة ورضاك التام عن العاملة المنزلية</p>
                </div>
              </div>
            </div>
            <div className="rental-cta">
              <h3>هل تحتاج عاملة منزلية بنظام الإيجار؟</h3>
              <p>تواصل معنا الآن للحصول على أفضل العروض</p>
              <div className="rental-buttons">
                <button className="hero-cta" onClick={() => showPage("contact")}>تواصل معنا</button>
                <a href="https://wa.me/966920020557" target="_blank" rel="noopener noreferrer" className="hero-cta outline">
                  <MessageCircle size={18} style={{ marginLeft: "8px" }} /> واتساب
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* STEPS PAGE */}
      {currentPage === "steps" && (
        <div data-testid="page-steps">
          <div className="page-header">
            <div className="section-badge gold">برنامج مساند</div>
            <h1>خطوات الاستقدام مع مساند</h1>
            <p>تجربة الاستقدام أسهل وأفضل</p>
          </div>
          <div className="section section-light">
            <div className="steps-intro">
              <h3>🌐 ما هي منصة مساند؟</h3>
              <p>منصة مساند هي إحدى مبادرات وزارة الموارد البشرية والتنمية الاجتماعية، وهي منصة إلكترونية متكاملة تهدف إلى تحسين تجربة استقدام العمالة المنزلية بشكل شامل. تسعى المنصة إلى تبسيط إجراءات الاستقدام وضمان حقوق جميع الأطراف من خلال توعية أصحاب العمل والعمالة المنزلية بحقوقهم وواجباتهم.</p>
            </div>
            <div className="section-header">
              <div className="section-badge">الخطوات</div>
              <h2 className="section-title">- خطوات الاستقدام مع مساند -</h2>
              <p className="section-sub">اتبع هذه الخطوات السهلة للحصول على العمالة المنزلية المناسبة لك</p>
            </div>
            <div className="steps-grid">
              <div className="step-card"><div className="step-num">١</div><h3>تحديد نوع الاستقدام</h3><p>اختيار نوع الاستقدام حسب التفضيل، إما استقدام عامل بمواصفات محددة أو استقدام عامل محدد مسبقاً بالاسم</p></div>
              <div className="step-card"><div className="step-num">٢</div><h3>استلام عروض الاستقدام</h3><p>استلام عروض طلبات الاستقدام من مقدمي الخدمة، تتضمن الراتب المستحق للعامل مع سير ذاتية ليتم ترتيبها حسب الأفضلية</p></div>
              <div className="step-card"><div className="step-num">٣</div><h3>تحديد مقدم الخدمة</h3><p>اختيار نوع الاستقدام حسب التفضيل، إما استقدام عامل بمواصفات محددة أو استقدام عامل محدد مسبقاً بالاسم</p></div>
              <div className="step-card"><div className="step-num">٤</div><h3>دفع رسوم الاستقدام</h3><p>ادفع بأمان من خلال مساند بعد إنشاء العقد، يمكنك الاختيار ضمن عدة طرق للدفع: فيزا، ماستركارد، أو بطاقة مدى البنكية</p></div>
              <div className="step-card"><div className="step-num">٥</div><h3>تتبع طلب الاستقدام</h3><p>يمكنك متابعة رحلة طلب الاستقدام بكل سهولة من خلال حسابك في منصة مساند، تبدأ من إنشاء الطلب وحتى وصول العامل للمملكة</p></div>
              <div className="step-card"><div className="step-num">٦</div><h3>رسوم الاستقدام</h3><p>سداد رسوم تأشيرة العمالة عبر الخدمات الحكومية في البنك أو عبر الإنترنت بطرق دفع آمنة متعددة</p></div>
            </div>
            <div className="section-header" style={{ marginTop: "40px" }}>
              <div className="section-badge">تصفية البحث</div>
              <h2 className="section-title">استقدام حسب تفضيلاتك</h2>
            </div>
            <div className="filter-grid">
              <div className="filter-card"><h3>📋 حسب المواصفات</h3><p>حدد المواصفات التي تريدها في العاملة من حيث الخبرة والعمر والمؤهلات</p></div>
              <div className="filter-card gold"><h3>💼 حسب المهنة</h3><p>اختر نوع العمل المطلوب: طاهية، مربية أطفال، عاملة منزل، ممرضة، وغيرها</p></div>
              <div className="filter-card"><h3>🌍 حسب الجنسية</h3><p>اختر جنسية العاملة من بين دول متعددة حسب تفضيلك وتجربتك</p></div>
            </div>
            <div className="app-download">
              <h3>📱 تطبيق مساند للجوال</h3>
              <p>متاح لكلا النظامين — أندرويد وآيفون</p>
              <div className="app-buttons">
                <a href="#" className="app-btn">🍎 App Store</a>
                <a href="#" className="app-btn green">🤖 Google Play</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ABOUT PAGE */}
      {currentPage === "about" && (
        <div data-testid="page-about">
          <div className="page-header">
            <div className="section-badge gold">عن الاستقدام</div>
            <h1>وصول العمالة</h1>
            <p>خدمة سريعة ومتميزة حتى وصول العاملة إلى باب منزلك</p>
          </div>
          <div className="section section-light">
            <div className="intro-box">
              <h3>✈️ وصول العمالة المنزلية</h3>
              <p>يحرص فريق العمل باستمرار على تقديم خدمات سريعة ومميزة لاستقدام العمالة المنزلية في المملكة العربية السعودية، مع متابعة دائمة للعامل أو العاملة من خلال إعلام العميل بموعد وصول العمالة بدقة وسرعة عالية، بالإضافة إلى التنسيق لاستقبال العاملة المنزلية وتسليم الوثائق كاملة.</p>
              <p className="highlight">✅ توفر شركة السرعة ضمان الاستبدال في حال التغيب أو رفض العمل</p>
            </div>
            <div className="section-header">
              <div className="section-badge">خدمة العملاء</div>
              <h2 className="section-title">التزامنا بخدمتكم</h2>
            </div>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">🤝</div>
                <h3>خدمة عملاء احترافية</h3>
                <p>نعتمد دائماً على أحدث الأساليب والتقنيات في التعامل مع العملاء لضمان جودة استثنائية في الخدمات التي يقدمها مكتب الأعمال</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🔬</div>
                <h3>جودة عالية</h3>
                <p>نوفر كافة الأدوات اللازمة لدراسة السوق بهدف تطوير خدمات عالية الجودة في استقدام العمالة المنزلية</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">💎</div>
                <h3>شفافية كاملة</h3>
                <p>نتواصل باستمرار مع العملاء قبل وبعد وصول العمالة لتجاوز توقعاتهم ومتطلباتهم ونسعى لبناء علاقات طويلة الأمد</p>
              </div>
            </div>
            <div className="section-header" style={{ marginTop: "60px" }}>
              <div className="section-badge">الحقوق والواجبات</div>
              <h2 className="section-title">سياسات وقوانين الاستقدام داخل المملكة</h2>
              <p className="section-sub">حتى تتسنى لك الفرصة باستقدام عمالة منزلية داخل المملكة، يجب مراعاة الضوابط التي أقرّتها الحكومة طبقاً للدستور السعودي لضمان حقوق كلا الطرفين.</p>
            </div>
            <div className="rights-grid">
              <div className="rights-card green-border">
                <h3>👨‍💼 حقوق وواجبات صاحب العمل</h3>
                <ul>
                  <li>✅ توفير السكن المناسب والغذاء الكافي للعاملة</li>
                  <li>✅ صرف الراتب المتفق عليه في الموعد المحدد</li>
                  <li>✅ منح العاملة إجازتها السنوية المستحقة</li>
                  <li>✅ توفير الرعاية الصحية اللازمة</li>
                  <li>✅ احترام خصوصية العاملة وكرامتها</li>
                  <li>✅ إعادة جواز سفرها عند انتهاء العقد</li>
                </ul>
              </div>
              <div className="rights-card gold-border">
                <h3>👩 حقوق وواجبات العمالة المنزلية</h3>
                <ul>
                  <li>✅ أداء العمل بأمانة واحترافية</li>
                  <li>✅ الالتزام بالعقد الموقع وشروطه</li>
                  <li>✅ احترام خصوصية صاحب العمل وأسرته</li>
                  <li>✅ الحق في الحصول على راتبها كاملاً</li>
                  <li>✅ الحق في يوم راحة أسبوعي</li>
                  <li>✅ الحق في التواصل مع أسرتها في بلدها</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* PRIVACY PAGE */}
      {currentPage === "privacy" && (
        <div data-testid="page-privacy">
          <div className="page-header">
            <div className="section-badge gold">الخصوصية</div>
            <h1>سياسة الخصوصية</h1>
            <p>نحن ملتزمون بحماية خصوصيتك وبياناتك الشخصية</p>
          </div>
          <div className="section section-light">
            <div className="privacy-container">
              <div className="privacy-header-card">
                <h3>🔒 التزامنا بالخصوصية</h3>
                <p>تلتزم شركة السرعة للاستقدام بحماية خصوصية زوار وعملائها، وتضع سياسة خصوصية شفافة وواضحة لتوضيح كيفية جمع واستخدام وحماية المعلومات الشخصية التي نجمعها. نعتبر خصوصية زوارنا وعملائنا أمراً بالغ الأهمية ونعمل جاهدين على حمايتها.</p>
              </div>
              <div className="privacy-card">
                <h3>📥 جمع المعلومات الشخصية</h3>
                <p>تجمع شركة السرعة للاستقدام المعلومات الشخصية من زوار الموقع وعملائها، مثل الاسم ورقم الهاتف والبريد الإلكتروني وتفاصيل الوظيفة والمؤهلات. يتم جمع هذه المعلومات لتمكيننا من تقديم خدماتنا بشكل أفضل وتحسين تجربة المستخدم.</p>
              </div>
              <div className="privacy-card">
                <h3>🛡️ حماية المعلومات الشخصية</h3>
                <p>تلتزم شركة السرعة للاستقدام بحماية المعلومات الشخصية التي تجمعها من الوصول غير المصرح به، وتستخدم أحدث التقنيات لحماية المعلومات الشخصية من الخسارة أو السرقة أو الوصول غير المصرح به.</p>
              </div>
              <div className="privacy-card">
                <h3>📊 استخدام المعلومات الشخصية</h3>
                <p>تستخدم شركة السرعة للاستقدام المعلومات الشخصية التي تجمعها لأغراض الاتصال والتواصل مع زوار الموقع وعملائها، وليس لأي غرض آخر، مثل الإعلان أو التسويق.</p>
              </div>
              <div className="privacy-card">
                <h3>🤝 مشاركة المعلومات الشخصية</h3>
                <p>لا تقوم شركة السرعة للاستقدام بمشاركة أي معلومات شخصية مع أي جهة خارجية دون موافقة صريحة من الزوار والعملاء.</p>
              </div>
              <div className="privacy-card">
                <h3>🔄 تحديث السياسة</h3>
                <p>قد تقوم شركة السرعة للاستقدام بتحديث سياسة الخصوصية بشكل دوري، ويجب على الزوار والعملاء التحقق بشكل منتظم من التحديثات الجديدة للسياسة.</p>
              </div>
              <div className="privacy-card">
                <h3>📞 الاتصال بالشركة</h3>
                <p>يمكن للزوار والعملاء الاتصال بشركة السرعة للاستقدام في حالة وجود أي أسئلة أو استفسارات حول سياسة الخصوصية، وذلك عبر البريد الإلكتروني أو الاتصال بالرقم الموضح على الموقع. الرقم الموحد: <strong style={{ color: "var(--green)" }}>920020557</strong></p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ARTICLES PAGE */}
      {currentPage === "articles" && (
        <div data-testid="page-articles">
          <div className="page-header">
            <div className="section-badge gold">المدونة</div>
            <h1>مقالات شركة السرعة</h1>
            <p>كل ما تحتاج معرفته عن استقدام العمالة المنزلية</p>
          </div>
          <div className="section section-light">
            <div className="articles-grid">
              <div className="article-card">
                <div className="article-img" style={{ background: "linear-gradient(135deg, #1e3a5f, #2c5282)" }}>✈️</div>
                <div className="article-body">
                  <span className="article-tag">الاستقدام</span>
                  <h3>كيف تختار العاملة المنزلية المناسبة لبيتك؟</h3>
                  <p>دليل شامل لاختيار العاملة المنزلية المثالية بناءً على احتياجات أسرتك وميزانيتك...</p>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span className="article-meta">📅 مارس 2025</span>
                    <a className="read-more">اقرأ المزيد ←</a>
                  </div>
                </div>
              </div>
              <div className="article-card">
                <div className="article-img" style={{ background: "linear-gradient(135deg, #3182ce, #63b3ed)" }}>📋</div>
                <div className="article-body">
                  <span className="article-tag">مساند</span>
                  <h3>شرح كامل لخطوات الاستقدام عبر منصة مساند</h3>
                  <p>تعرف على جميع خطوات الاستقدام بالتفصيل عبر منصة مساند الحكومية خطوة بخطوة...</p>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span className="article-meta">📅 فبراير 2025</span>
                    <a className="read-more">اقرأ المزيد ←</a>
                  </div>
                </div>
              </div>
              <div className="article-card">
                <div className="article-img" style={{ background: "linear-gradient(135deg, #2c3e50, #1e3a5f)" }}>⚖️</div>
                <div className="article-body">
                  <span className="article-tag">قوانين</span>
                  <h3>حقوق وواجبات صاحب العمل والعاملة المنزلية</h3>
                  <p>تعرف على حقوقك وواجباتك كصاحب عمل وما هي حقوق العاملة المنزلية التي يكفلها النظام...</p>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span className="article-meta">📅 يناير 2025</span>
                    <a className="read-more">اقرأ المزيد ←</a>
                  </div>
                </div>
              </div>
              <div className="article-card">
                <div className="article-img" style={{ background: "linear-gradient(135deg, #8e44ad, #6a1a8f)" }}>💳</div>
                <div className="article-body">
                  <span className="article-tag">رسوم</span>
                  <h3>كم تبلغ رسوم استقدام العمالة المنزلية؟</h3>
                  <p>دليل شامل لجميع رسوم الاستقدام من التأشيرة وحتى وصول العاملة إلى المملكة...</p>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span className="article-meta">📅 ديسمبر 2024</span>
                    <a className="read-more">اقرأ المزيد ←</a>
                  </div>
                </div>
              </div>
              <div className="article-card">
                <div className="article-img" style={{ background: "linear-gradient(135deg, #e74c3c, #c0392b)" }}>🌍</div>
                <div className="article-body">
                  <span className="article-tag">جنسيات</span>
                  <h3>أفضل الجنسيات للعمالة المنزلية وميزات كل منها</h3>
                  <p>مقارنة بين أبرز جنسيات العمالة المنزلية المتاحة ومميزات كل جنسية ومدى ملاءمتها...</p>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span className="article-meta">📅 نوفمبر 2024</span>
                    <a className="read-more">اقرأ المزيد ←</a>
                  </div>
                </div>
              </div>
              <div className="article-card">
                <div className="article-img" style={{ background: "linear-gradient(135deg, #1e3a5f, #3182ce)" }}>🏠</div>
                <div className="article-body">
                  <span className="article-tag">نصائح</span>
                  <h3>نصائح للتعامل مع العاملة المنزلية الجديدة</h3>
                  <p>كيف تستقبلين العاملة المنزلية الجديدة وتوضحين لها المهام والتوقعات لبداية ناجحة...</p>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span className="article-meta">📅 أكتوبر 2024</span>
                    <a className="read-more">اقرأ المزيد ←</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CONTACT PAGE */}
      {currentPage === "contact" && (
        <div data-testid="page-contact">
          <div className="page-header">
            <div className="section-badge gold">تواصل معنا</div>
            <h1>نتشرف بتواصلكم معنا</h1>
            <p>جاهزون للرد على جميع استفساراتكم</p>
          </div>
          <div className="section section-light">
            <div className="contact-flex">
              <div className="contact-info">
                <div className="section-badge">معلومات التواصل</div>
                <h2>شركة السرعة للاستقدام</h2>
                <p>نسعد بخدمتكم والإجابة على جميع استفساراتكم في أي وقت</p>
                <div className="contact-item">
                  <div className="contact-item-icon"><Phone size={18} color="#fff" /></div>
                  <div className="contact-item-text"><h4>الرقم الموحد</h4><p>920020557</p></div>
                </div>
                <div className="contact-item">
                  <div className="contact-item-icon"><MessageCircle size={18} color="#fff" /></div>
                  <div className="contact-item-text"><h4>واتساب</h4><p>966920020557+</p></div>
                </div>
                <div className="contact-item">
                  <div className="contact-item-icon"><Mail size={18} color="#fff" /></div>
                  <div className="contact-item-text"><h4>البريد الإلكتروني</h4><p>alqafieimanpower@hotmail.com</p></div>
                </div>
                <div className="contact-item">
                  <div className="contact-item-icon"><MapPin size={18} color="#fff" /></div>
                  <div className="contact-item-text"><h4>العنوان</h4><p>حائل، المملكة العربية السعودية</p></div>
                </div>
                <a href="https://wa.me/966920020557" target="_blank" rel="noopener noreferrer" className="wa-btn" data-testid="contact-whatsapp-btn">
                  <MessageCircle size={18} /> تواصل عبر واتساب الآن
                </a>
                <div className="map-placeholder">🗺️ موقعنا على الخريطة — حائل، المملكة العربية السعودية</div>
              </div>
              <div className="contact-form">
                <h2>أرسل لنا رسالة</h2>
                <div className="form-group">
                  <label>الاسم كامل *</label>
                  <input type="text" placeholder="أ. محمد محمد" data-testid="contact-name-input" />
                </div>
                <div className="form-group">
                  <label>رقم الجوال *</label>
                  <input type="tel" placeholder="05XXXXXXXX" data-testid="contact-phone-input" />
                </div>
                <div className="form-group">
                  <label>البريد الإلكتروني *</label>
                  <input type="email" placeholder="example@gmail.com" data-testid="contact-email-input" />
                </div>
                <div className="form-group">
                  <label>نوع الخدمة</label>
                  <select data-testid="contact-service-select">
                    <option value="">اختر نوع الخدمة</option>
                    <option>إصدار تأشيرة</option>
                    <option>اختيار العمالة</option>
                    <option>تعاقد الاستقدام</option>
                    <option>استفسار عام</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>الرسالة *</label>
                  <textarea placeholder="اكتب رسالتك هنا..." data-testid="contact-message-input"></textarea>
                </div>
                <button className="submit-btn" onClick={sendForm} data-testid="contact-submit-btn">📨 إرسال الرسالة</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FOOTER */}
      <footer data-testid="main-footer">
        <div className="footer-grid">
          <div className="footer-brand">
            <img 
              src="https://customer-assets.emergentagent.com/job_kind-euclid-5/artifacts/fex1xyc7_WhatsApp%20Image%202026-03-02%20at%206.43.32%20PM.jpeg" 
              alt="شركة السرعة للاستقدام" 
              className="footer-logo"
            />
            <p>وجهتك الأولى في الاستقدام بأسعار تنافسية وأفضل اختيار للعمالة ونقل الخدمات في حائل والمملكة العربية السعودية</p>
            <div className="footer-social" style={{ marginTop: "16px" }}>
              <a href="https://wa.me/966920020557" target="_blank" rel="noopener noreferrer"><MessageCircle size={14} /></a>
              <a href="#"><Facebook size={14} /></a>
              <a href="#"><Instagram size={14} /></a>
              <a href="#"><X size={14} /></a>
              <a href="#"><Music size={14} /></a>
            </div>
          </div>
          <div className="footer-col">
            <h4>روابط سريعة</h4>
            <ul>
              <li><a onClick={() => showPage("home")}>الصفحة الرئيسية</a></li>
              <li><a onClick={() => showPage("prices")}>أسعار الاستقدام</a></li>
              <li><a onClick={() => showPage("rental")}>عاملات الإيجار</a></li>
              <li><a onClick={() => showPage("steps")}>خطوات الاستقدام</a></li>
              <li><a onClick={() => showPage("about")}>عن الاستقدام</a></li>
              <li><a onClick={() => showPage("contact")}>تواصل معنا</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>معلومات الشركة</h4>
            <ul>
              <li><a href="tel:920020557">📞 920020557</a></li>
              <li><a href="https://wa.me/966920020557" target="_blank" rel="noopener noreferrer">💬 واتساب: 920020557</a></li>
              <li><a href="mailto:alqafieimanpower@hotmail.com">✉️ alqafieimanpower@hotmail.com</a></li>
              <li><a href="#">📍 حائل، المملكة العربية السعودية</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2025 شركة السرعة للاستقدام - حائل. جميع الحقوق محفوظة.</p>
          <p style={{ opacity: 0.5 }}>الرقم الموحد: 920020557</p>
        </div>
      </footer>

      {/* FLOATING BUTTONS */}
      <div className="float-btns" data-testid="float-buttons">
        <a href="https://wa.me/966920020557" target="_blank" rel="noopener noreferrer" className="float-btn float-whatsapp" title="واتساب" data-testid="float-whatsapp">
          <MessageCircle size={22} color="#fff" />
        </a>
        <a href="tel:920020557" className="float-btn float-phone" title="اتصل بنا" data-testid="float-phone">
          <Phone size={22} color="#fff" />
        </a>
      </div>

      {/* TOAST */}
      <div className={`toast ${showToast ? "show" : ""}`} data-testid="toast-message">
        ✅ تم إرسال رسالتك بنجاح! سنتواصل معك قريباً
      </div>
    </div>
  );
}

export default App;
